const SENSITIVE_KEY = /url|uri|body|host|address|ip|header|cookie|authorization|password|token/i;

export function logInfo(event: string, fields: Record<string, string | number | boolean | null> = {}): void {
  const safe = sanitize(fields);
  console.log(JSON.stringify({ level: 'info', time: new Date().toISOString(), event, ...safe }));
}

export function logError(event: string, fields: Record<string, string | number | boolean | null> = {}): void {
  const safe = sanitize(fields);
  console.error(JSON.stringify({ level: 'error', time: new Date().toISOString(), event, ...safe }));
}

function sanitize(fields: Record<string, string | number | boolean | null>) {
  const safe: Record<string, string | number | boolean | null> = {};
  for (const [key, value] of Object.entries(fields)) {
    if (SENSITIVE_KEY.test(key)) continue;
    safe[key] = value;
  }
  return safe;
}
